import React from "react";
import { Flex, Text, Button, HStack, VStack } from "@chakra-ui/react";

const ActivityHeader = ({
  icon,
  title,
  subtitle = "Edit the details below to fine-tune your activity",
  onCancel,
  onSave,
  isLoading = false,
  isDisabled = false,
  color = "#FDB022", // Default color for backwards compatibility
}) => {
  return (
    <VStack spacing={3} align="stretch" w="full">
      {/* Header Content */}
      <Flex
        justify="space-between"
        align="center"
        bg="white"
        borderRadius="8px"
        p={3}
        gap={3}
      >
        {/* Title Container */}
        <HStack spacing={3} flex={1}>
          {/* Icon Container */}
          <Flex
            w="33px"
            h="33px"
            bg={color}
            borderRadius="50%"
            align="center"
            justify="center"
            flexShrink={0}
          >
            <Text fontSize="16px" lineHeight="1.5">
              {icon}
            </Text>
          </Flex>

          {/* Title Text */}
          <VStack spacing="5px" align="start">
            <Text
              fontSize="16px"
              fontWeight="400"
              lineHeight="1.5"
              letterSpacing="-0.02em"
              color="#0C001C"
              fontFamily="Geist, sans-serif"
            >
              {title}
            </Text>
          </VStack>
        </HStack>

        {/* Buttons */}
        <HStack spacing={3}>
          {/* Cancel Button */}
          <Button
            variant="ghost"
            fontSize="13px"
            fontWeight="700"
            lineHeight="1.23"
            color="#0C001C"
            fontFamily="Geist, sans-serif"
            p={2}
            minW="auto"
            h="auto"
            onClick={onCancel}
          >
            Cancel
          </Button>

          {/* Save Button */}
          <Button
            bg="#4C47CC"
            color="white"
            fontSize="13px"
            fontWeight="700"
            lineHeight="1.23"
            fontFamily="Geist, sans-serif"
            borderRadius="8px"
            p={2}
            minW="48px"
            h="auto"
            isLoading={isLoading}
            isDisabled={isDisabled}
            _hover={{ bg: "#3D39A3" }}
            _active={{ bg: "#3D39A3" }}
            _disabled={{ bg: "gray.300", color: "gray.500" }}
            onClick={onSave}
            data-testid="activity-save-button"
          >
            Save
          </Button>
        </HStack>
      </Flex>

      {/* Subtitle */}
      <Text
        fontSize="16px"
        fontWeight="84"
        lineHeight="1.5"
        letterSpacing="-0.02em"
        color="#726682"
        fontFamily="Geist, sans-serif"
      >
        {subtitle}
      </Text>
    </VStack>
  );
};

export default ActivityHeader;
